module.exports = {"TXTWCL_Responsible_gaming":{"id":"TXTWCL_Responsible_gaming","defaultMessage":"Ansvarsfullt spelande","track":"Responsible gaming"}}